import * as React from 'react';
import Loader from '../../components/Loader';
import NotFound from '../NotFound';
import EditProductVariant from './EditProductVariant';
import { useRequest, getHeaders } from '../../api/client';
import { ProfileContext, ProfileManager } from '../../profile';
import { RouteComponentProps } from 'react-router';
import { Variant } from '../../product';

const variant = (id: string, productId: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/products/${productId}/variants/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const newVariant = (productId: string): Variant => ({
  attributes: [],
  description_text: '',
  dimensions: {
    unit: 'mm',
    width: 0,
    height: 0,
    depth: 0,
  },
  id: null,
  name: '',
  position: 0,
  available: true,
  price: {
    value: 0,
    currency: 'GBP',
    taxable: false,
    tax_code: '',
  },
  product_id: productId,
  sku: '',
  stock_policy: 'out_of_stock',
  weight: 0,
  weight_unit: 'g',
  in_stock: true,
  stock_count: 0,
});

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.variant : null;
};

const getProductID = (props: RouteComponentProps<any>) => {
  return props.match.params.productId;
};

const getEntityID = (props: RouteComponentProps<any>) => {
  return props.match.params.variantId;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component variant={preloadedEntity} />;
    }

    if (getEntityID(props) === 'new') {
      return <Component variant={newVariant(getProductID(props))} />;
    }

    const state = variant(getEntityID(props), getProductID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component variant={state.data} />;
  };
}

export default withState(EditProductVariant);
